import {translations} from 'presentation/translations-new';

const {healthServicesNames, odontoServicesNames} =
	translations['pt-br'].privateFlow.guideFlow.guideDetails;

enum GuideStep {
	LOCATION = 'LOCATION',
	DETAILS = 'DETAILS',
	RESULTS = 'RESULTS',
}

enum ServiceIconEnum {
	DOCTORS_OFFICES_AND_CLINICS = 'stethoscope',
	ELECTIVE_HOSPITAL = 'building-outline',
	URGENT_AND_EMERGENCY_CARE = 'local-hospital-outline',
	AUXILIARY_DIAGNOSTIC_AND_THERAPY_SERVICES = 'medical-services-default',
	MATERNITY = 'child-care',
	URGENT_DAYTIME_CARE = 'local-hospital-day-outline',
	URGENT_NIGHT_CARE = 'local-hospital-night-outline',
}

type ServiceInfo = {
	icon: ServiceIconEnum;
	label: string;
};

const ServiceMap: Record<string, ServiceInfo> = {
	'CONSULTORIOS/CLINICAS': {
		icon: ServiceIconEnum.DOCTORS_OFFICES_AND_CLINICS,
		label: healthServicesNames.doctorsOfficesAndClinics,
	},
	'HOSPITAL ELETIVO': {
		icon: ServiceIconEnum.ELECTIVE_HOSPITAL,
		label: healthServicesNames.electiveHospital,
	},
	'PRONTO SOCORRO URGEN/EMERGEN': {
		icon: ServiceIconEnum.URGENT_AND_EMERGENCY_CARE,
		label: healthServicesNames.urgentAndEmergencyCare,
	},
	'SERVICOS AUXILIARES DE DIAGNOSTICO E TERAPIA': {
		icon: ServiceIconEnum.AUXILIARY_DIAGNOSTIC_AND_THERAPY_SERVICES,
		label: healthServicesNames.auxiliaryDiagnosticAndTherapyServices,
	},
	MATERNIDADE: {
		icon: ServiceIconEnum.MATERNITY,
		label: healthServicesNames.maternity,
	},
	'PRONTO SOCORRO URGENCIA DIURNA': {
		icon: ServiceIconEnum.URGENT_DAYTIME_CARE,
		label: odontoServicesNames.urgentDaytimeCare,
	},
	'PRONTO SOCORRO 24 HRS URGEN/EMERGEN': {
		icon: ServiceIconEnum.URGENT_AND_EMERGENCY_CARE,
		label: odontoServicesNames.urgentAndEmergencyCare,
	},
	'PRONTO SOCORRO URGENCIA NOTURNA': {
		icon: ServiceIconEnum.URGENT_NIGHT_CARE,
		label: odontoServicesNames.urgentNightCare,
	},
	'PRONTO SOCORRO URGENCIA NOTURNA SOBREAVISO': {
		icon: ServiceIconEnum.URGENT_NIGHT_CARE,
		label: odontoServicesNames.urgentNightOnCallCare,
	},
	'PRONTO SOCORRO URGENCIA DIURNA SOBREAVISO': {
		icon: ServiceIconEnum.URGENT_DAYTIME_CARE,
		label: odontoServicesNames.urgentDaytimeOnCallCare,
	},
};

const stepMap: Record<GuideStep, {step: GuideStep; active: number}> = {
	[GuideStep.LOCATION]: {step: GuideStep.LOCATION, active: 0},
	[GuideStep.DETAILS]: {step: GuideStep.DETAILS, active: 1},
	[GuideStep.RESULTS]: {step: GuideStep.RESULTS, active: 2},
};

const ONA_QUALIFICATION_CODES = [16, 17, 18];

export {
	stepMap,
	ServiceMap,
	ONA_QUALIFICATION_CODES,
	ServiceIconEnum,
	GuideStep
};
export type {ServiceInfo};
